/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserReportStatus } from './UserReportStatus';
import {
    UserReportStatusFromJSON,
    UserReportStatusFromJSONTyped,
    UserReportStatusToJSON,
    UserReportStatusToJSONTyped,
} from './UserReportStatus';

/**
 * Schema for a superadmin updating the triage state of a report.
 * @export
 * @interface UserReportUpdate
 */
export interface UserReportUpdate {
    /**
     * 
     * @type {UserReportStatus}
     * @memberof UserReportUpdate
     */
    status?: UserReportStatus | null;
    /**
     * 
     * @type {string}
     * @memberof UserReportUpdate
     */
    admin_note?: string | null;
}



/**
 * Check if a given object implements the UserReportUpdate interface.
 */
export function instanceOfUserReportUpdate(value: object): value is UserReportUpdate {
    return true;
}

export function UserReportUpdateFromJSON(json: any): UserReportUpdate {
    return UserReportUpdateFromJSONTyped(json, false);
}

export function UserReportUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserReportUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : UserReportStatusFromJSON(json['status']),
        'admin_note': json['admin_note'] == null ? undefined : json['admin_note'],
    };
}

export function UserReportUpdateToJSON(json: any): UserReportUpdate {
    return UserReportUpdateToJSONTyped(json, false);
}

export function UserReportUpdateToJSONTyped(value?: UserReportUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': UserReportStatusToJSON(value['status']),
        'admin_note': value['admin_note'],
    };
}

